import { styled } from '@clickcease/cc-client-components-lib'
import { UserMenuStyled as UserMenu } from 'Components/Elements/UserMenu/UserMenu.styled'

const border = '1px solid $lightNeutral'

export const SelectWrapper = styled('div', {
  all: 'unset',
  marginRight: '$4',
  marginLeft: '$8',
  height: '24px',
  display: 'flex',
  paddingInline: '$4',
  alignItems: 'center',
  borderRight: border,
  borderLeft: border,
})

export const UserMenuStyled = styled(UserMenu, {
  '@laptop': {
    left: '-$9',
  },
})
